// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"83":"d654f877","361":"45abe3cc","488":"e5c40751","537":"d0ebd8e1","709":"a244ea68","978":"03fc8079"}[chunkId] + ".css";
};